



















































import Vue from "vue";
import { debounce } from "@/fp";
import { LabelTreshHold, MipCognniCombination } from "../data/model";
import { ref, Ref, computed } from "@vue/composition-api";
export default Vue.extend({
  props: ["item"],
  setup(props, { emit }) {
    const is_loading_label = ref(false);

    const _item = computed(() => props.item as MipCognniCombination);

    const label_last_value: Ref<Record<string, number>> = ref({});

    const on_level_changed = debounce(500)((value: string, label: any) => {
      let num_val = value.trim().length === 0 ? 67 : +value;
      const { min, max } = LabelTreshHold;
      num_val = num_val < min ? min : num_val > max ? max : num_val;
      label_last_value.value = {
        ...label_last_value.value,
        [label.labelId]: num_val,
      };
      label.last = num_val;
      emit("change_now_for_ui", { id: label.labelId, value: num_val });
      if (num_val !== label.confidenceThreshold) {
        changeThreshold(num_val, label);
      }
    });

    const changeThreshold = debounce(500)((value: number, label: any) => {
      const { min, max } = LabelTreshHold;
      value = value < min ? min : value > max ? max : value;
      if (value !== label.confidenceThreshold) {
        is_loading_label.value = true;
        emit("changeTrashHold", {
          id: label.labelId,
          value,
          done: () => {
            is_loading_label.value = false;
          },
        });
      }
    });
    const open_overrides_modal = () => {
      emit("open_override_modal", {
        label_id: _item.value.labelId,
        mip_label_id: _item.value.externalLabelId,
        label_name: _item.value.runtime.label_name,
        label_code: _item.value.runtime.parent_code,
      });
    };

    return {
      is_loading_label,
      on_level_changed,
      open_overrides_modal,
    };
  },
});
